import { Navigate, useLocation } from "react-router-dom";
import { isAuthed } from "@/lib/auth";

export default function AdminProtectedRoute({ children }) {
  const location = useLocation();
  if (!isAuthed()) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
